export { default } from './CommonStatisticsChart'
